export enum UserStatus {
  student = "student",
  graduating = "graduand",
  graduated = "graduated",
}
